
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/category/[category]",
      function () {
        return require("private-next-pages/insights/category/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/category/[category]"])
      });
    }
  